var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner"},[(_vm.topNav.imgUrl)?_c('img',{staticClass:"banner-img",attrs:{"src":_vm.topNav.imgUrl,"alt":_vm.topNav.name}}):_c('div',{staticClass:"empty"})])
}
var staticRenderFns = []

export { render, staticRenderFns }